export enum CountryCode {
  UNSET_COUNTRY_CODE = 'UNSET_COUNTRY_CODE',
  MX = 'MX',
  US = 'US',
}
